import { merge } from '../../helper';
import insertAfter from '../../general/insertAfter';

import * as exElement from '../../utils/element';

import * as exResize from './resize';
import alreadyTableBody from './utils/alreadyTableBody';
import alreadyTableWrapper from './utils/alreadyTableWrapper';
import rowHidden from './utils/rowHidden';

// ----------------------------------------------------------------------------

function start(element: HTMLElement, config: Record<string, any> = {}): void {
    // Get element (table scroll)
    const elTableScroll = element.closest('.table-scroll');
    // If there is no element (table scroll)
    if (!elTableScroll) {
        // Create element (table scroll)
        create(element, config);
    }
}

function create(element: HTMLElement, config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // --------------------------------------------------------------------

    //
    const build: Record<string, any> = {
        elements: {},
    };

    // Create element (table wrapper)
    const elTableWrapper = alreadyTableWrapper(element);
    build.element = elTableWrapper;

    // --------------------------------------------------------------------

    // Create element (table scroll)
    const elTableScroll = exElement.create({
        merge: defConfig,
        class: {
            add: 'table-scroll',
        },
    });
    elTableWrapper.appendChild(elTableScroll);
    build.elements.scroll = elTableScroll;

    //
    insertAfter(elTableScroll, element);

    // --------------------------------------------------------------------

    // Get element (thead)
    const elTableHead = element.querySelector('thead');
    // If there is element (thead)
    if (elTableHead) {
        // Create element (table scroll head)
        const elTableScrollHead = exElement.create({
            merge: defConfig.thead,
            class: {
                add: 'table-scroll-head',
            },
            style: {
                paddingRight: '17px',
            },
        });
        elTableScroll.appendChild(elTableScrollHead);
        build.elements.head = elTableScrollHead;

        // Clone element (table head)
        const elTableCopy = element.cloneNode(true) as HTMLTableElement;
        elTableCopy.innerHTML = '';
        const elTableHeadCopy = elTableHead.cloneNode(true);

        elTableCopy.appendChild(elTableHeadCopy);
        elTableScrollHead.appendChild(elTableCopy);
    }

    // --------------------------------------------------------------------

    // Create element (tbody)
    const elTableBody = alreadyTableBody(element, defConfig.tbody);
    // If there is element (tbody)
    if (elTableBody) {
        // Create element (table scroll body)
        const elTableScrollBody = exElement.create({
            merge: defConfig.tbody,
            class: {
                add: 'table-scroll-body',
            },
            style: {
                // maxHeight: defConfig.scrollHeight,
                overflowY: 'scroll',
            },
        });
        elTableScroll.appendChild(elTableScrollBody);
        build.elements.body = elTableScrollBody;

        // --

        rowHidden(element, 'thead');
        rowHidden(element, 'tfoot');

        // --

        element.appendChild(elTableBody);
        elTableScrollBody.appendChild(element);
    }

    // --------------------------------------------------------------------

    // Get element (tfoot)
    const elTableFoot = element.querySelector('tfoot');
    // If there is element (tfoot)
    if (elTableFoot) {
        // Create element (table scroll foot)
        const elTableScrollFoot = exElement.create({
            merge: defConfig.tfoot,
            class: {
                add: 'table-scroll-foot',
            },
            style: {
                paddingRight: '17px',
            },
        });
        elTableScroll.appendChild(elTableScrollFoot);
        build.elements.foot = elTableScrollFoot;

        // Clone element (table foot)
        const elTableCopy = element.cloneNode(true) as HTMLTableElement;
        elTableCopy.innerHTML = '';
        const elTableFootCopy = elTableFoot.cloneNode(true);

        elTableCopy.appendChild(elTableFootCopy);
        elTableScrollFoot.appendChild(elTableCopy);
    }

    // --------------------------------------------------------------------

    // Resize Scroll
    exResize.scroll(elTableScroll);

    // --------------------------------------------------------------------

    // Return
    return build;
}

// ----------------------------------------------------------------------------

export { start, create };
